module.exports = __webpack_public_path__ + "img/3d.f971c55b.svg";